// Central business config — edit these to update the whole site.

export const BUSINESS = {
  name: "Roddy's",
  fullName: "Roddy's Gardening Services",
  tagline: "We keep your property looking its best",
  blurb: "Reliable, affordable and high-quality lawn and property maintenance you can count on.",
  hourlyRate: 80,
  email: "roddysbusinessacc@gmail.com",
  phone: "0494 693 502",
  phoneRaw: "0494693502",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchReviews() {
  const res = await fetch(`${API}/reviews`);
  if (!res.ok) throw new Error("Failed to load reviews");
  return res.json();
}

export async function submitReview({ name, rating, comment }) {
  const res = await fetch(`${API}/reviews`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, rating, comment }),
  });
  if (!res.ok) throw new Error("Failed to submit review");
  return res.json();
}

export const LOGO_URL = "/logo-gardening.png";

export const LOGO_TRANSPARENT = "/logo-transparent.png";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/dffaaa5a-dbf9-4325-a79f-c89fe00804de/images/c83532fa3daea0e6d818ac21b7250e4322d59b7aef25baf3cab0acd2e5d0d160.jpeg",
  edging: "https://images.unsplash.com/photo-1778272068639-4fd0a03e6ef5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  edging2: "https://images.unsplash.com/photo-1768407313789-0eccf91f67ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mower: "https://images.unsplash.com/photo-1690068023694-053da714f95f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gardenPath: "https://images.unsplash.com/photo-1663185776834-0c86f6ced17b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  { id: "mowing", icon: "Tractor", label: "Lawn Mowing", base: 0.5,
    desc: "Crisp, even cuts that keep your lawn healthy and looking sharp." },
  { id: "edging", icon: "Scissors", label: "Edging & Whipper Snipping", base: 0.35,
    desc: "Clean edges along paths, driveways and borders for that finished look." },
  { id: "weeding", icon: "Sprout", label: "Weeding & Garden Clean-Ups", base: 0.6,
    desc: "Beds weeded, debris cleared and gardens tidied from top to bottom." },
  { id: "property", icon: "Wrench", label: "Property Maintenance", base: 0.5,
    desc: "General upkeep to keep your whole property neat and well cared for." },
];

export const SIZES = [
  { id: "small", label: "Small", note: "Courtyard / unit · under 300m²", factor: 1 },
  { id: "medium", label: "Medium", note: "Standard yard · 300–800m²", factor: 1.7 },
];

export const CONDITIONS = [
  { id: "maintained", label: "Well maintained", note: "Just needs a regular tidy", factor: 1 },
  { id: "light", label: "A little overgrown", note: "Been a few weeks", factor: 1.3 },
  { id: "overgrown", label: "Quite overgrown", note: "Needs a solid catch-up", factor: 1.75 },
];

export const FREQUENCIES = [
  { id: "oneoff", label: "One-off", note: "A single visit" },
  { id: "weekly", label: "Weekly", note: "Every week" },
  { id: "fortnightly", label: "Fortnightly", note: "Every 2 weeks" },
  { id: "monthly", label: "Monthly", note: "Once a month" },
];

const roundToHalf = (n) => Math.round(n * 2) / 2;

export function calculateQuote({ services, size, condition }) {
  const sizeFactor = SIZES.find((s) => s.id === size)?.factor ?? 1;
  const condFactor = CONDITIONS.find((c) => c.id === condition)?.factor ?? 1;
  const baseHours = (services || [])
    .map((id) => SERVICES.find((s) => s.id === id)?.base ?? 0)
    .reduce((a, b) => a + b, 0);

  let hours = baseHours * sizeFactor * condFactor;
  let lowHours = Math.max(1, roundToHalf(hours));
  let highHours = roundToHalf(lowHours + Math.max(0.5, lowHours * 0.35));

  const rate = BUSINESS.hourlyRate;
  return {
    lowHours,
    highHours,
    priceLow: Math.round(lowHours * rate),
    priceHigh: Math.round(highHours * rate),
    rate,
  };
}
